import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { withJamParams } from '../../util/recordingNavigation'

const RecordingPage = ({ supportEmail }) => {
  const location = useLocation()
  const contactEmail = supportEmail?.trim()
  const [jamUnavailable, setJamUnavailable] = useState(() => document.documentElement.dataset.jamUnavailable === 'true')

  useEffect(() => {
    const handleUnavailable = () => setJamUnavailable(true)
    window.addEventListener('store:jam-unavailable', handleUnavailable)
    return () => window.removeEventListener('store:jam-unavailable', handleUnavailable)
  }, [])

  return (
    <section aria-labelledby="recording-title" className="container py-5">
      <h1 id="recording-title">Record a problem</h1>
      {jamUnavailable ? (
        <>
          <p>The recording tool could not load. You can continue using the Store.</p>
          {contactEmail ? (
            <p>
              <a href={`mailto:${contactEmail}`}>Email support</a> to describe the problem instead.
            </p>
          ) : (
            <p>Reply to the person who sent you this recording link and describe the problem instead.</p>
          )}
        </>
      ) : (
        <>
          <p>The recording tool should open on this page. If it does not appear, try refreshing the page.</p>
          {contactEmail ? (
            <p>Still not working? <a href={`mailto:${contactEmail}`}>Email support</a> to describe the problem.</p>
          ) : (
            <p>Still not working? Reply to the person who sent you this recording link and describe the problem.</p>
          )}
        </>
      )}
      <Link to={withJamParams('/', location.search)}>Continue to Store</Link>
    </section>
  )
}

RecordingPage.propTypes = {
  supportEmail: PropTypes.string
}

export default RecordingPage
